import React from 'react';
import { cn } from '../../lib/utils';
import { getAgentTone } from '../../design-system/agentTones';

/**
 * OrkaLoader — canonical loading indicator (PRD §7.2).
 *
 * Three variants:
 *   spinner — circular, default
 *   dot — small pulsing dot (mobile / inline)
 *   shimmer — skeleton block (data picker, dashboard panes)
 */
export function OrkaLoader({
  variant = 'spinner',
  size = 'md',
  tone = 'thinking',
  label = 'Loading',
  className,
}) {
  const t = getAgentTone(tone);
  const SIZE = { sm: 12, md: 16, lg: 24 };
  const px = SIZE[size] || SIZE.md;

  if (variant === 'dot') {
    return (
      <span
        role="status"
        aria-label={label}
        className={cn('inline-block rounded-full animate-pulse', className)}
        style={{ width: px / 2, height: px / 2, backgroundColor: t.color }}
      />
    );
  }

  if (variant === 'shimmer') {
    return (
      <span
        role="status"
        aria-label={label}
        className={cn('inline-block rounded animate-pulse', className)}
        style={{
          width: '100%',
          height: px / 2,
          background: `linear-gradient(90deg, ${t.soft}, ${t.border}, ${t.soft})`,
          backgroundSize: '200% 100%',
        }}
      />
    );
  }

  return (
    <svg
      role="status"
      aria-label={label}
      className={cn('animate-spin shrink-0', className)}
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" stroke={t.color} strokeWidth="3" opacity="0.25" />
      <path d="M22 12a10 10 0 0 1-10 10" stroke={t.color} strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export default OrkaLoader;
